var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "el-core" },
    [
      _c("app-header", {
        attrs: { drawerOpen: _vm.drawerMenuOpen },
        on: { drawerMenuClicked: _vm.toggleDrawerMenu },
      }),
      _c("div", { staticClass: "el-core__wrapper" }, [
        _c("div", { staticClass: "el-main _navigation_horizontal" }, [
          _c("div", { staticClass: "el-main__navigation" }, [
            _c("div", { staticClass: "eu-pt_2" }, [_c("emd-tabbar")], 1),
          ]),
          _c("div", { staticClass: "el-main__content" }, [
            _c("div", { staticClass: "el-bounds" }, [
              _c(
                "div",
                { staticClass: "el-section" },
                [_c("router-view", { key: _vm.$route.path })],
                1
              ),
              _c("div", { staticClass: "el-section" }, [_c("emd-footer")], 1),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }